// Quiet after-state beat. No heading, no eyebrow. A pause between
// "How it works." and "About Kat."

export default function AfterState() {
  return (
    <section
      id="after-state"
      data-testid="section-after-state"
      className="bg-paper"
    >
      <div className="mx-auto max-w-[1100px] px-6 py-16 md:px-10 md:py-24">
        <div className="max-w-[620px]">
          <p
            data-testid="after-state-p1"
            style={{
              fontFamily: "Inter, Arial, sans-serif",
              fontSize: "clamp(1.1875rem, 1.5vw, 1.25rem)",
              lineHeight: 1.6,
              color: "rgba(26,58,79,0.88)",
              fontWeight: 400,
            }}
          >
            Six months from now, a big decision comes up. Your team runs the
            framework, makes the call, and tells you about it afterward.
          </p>

          <p
            data-testid="after-state-p2"
            className="mt-6"
            style={{
              fontFamily: "Inter, Arial, sans-serif",
              fontSize: "clamp(1.1875rem, 1.5vw, 1.25rem)",
              lineHeight: 1.6,
              color: "rgba(26,58,79,0.88)",
              fontWeight: 400,
            }}
          >
            That&rsquo;s the goal. Not a deck. Not a dependency.{" "}
            <span style={{ fontWeight: 500 }}>
              A team you trust to think and make big decisions.
            </span>
          </p>
        </div>
      </div>
    </section>
  );
}
